var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCircleFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 12.0001C21 7.02952 16.9706 3.00008 12 3.00008C7.02943 3.00008 3 7.02952 3 12.0001C3 16.4922 6.29117 20.2156 10.5938 20.8907V14.6016H8.30859V12.0001H10.5938V10.0173C10.5938 7.76164 11.9374 6.51571 13.9932 6.51571C14.9779 6.51571 16.0078 6.69149 16.0078 6.69149V8.90633H14.8729C13.7549 8.90633 13.4062 9.60009 13.4062 10.3118V12.0001H15.9023L15.5033 14.6016H13.4062V20.8907C17.7088 20.2156 21 16.4922 21 12.0001Z",
    fill: "#1877F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5033 14.6016L15.9023 12H13.4063V10.3117C13.4063 9.60001 13.7549 8.90625 14.8729 8.90625H16.0078V6.69141C16.0078 6.69141 14.9779 6.51562 13.9932 6.51562C11.9374 6.51562 10.5938 7.76156 10.5938 10.0172V12H8.30859V14.6016H10.5938V20.8907C11.052 20.9626 11.5216 21 12 21C12.4784 21 12.948 20.9626 13.4063 20.8907V14.6016H15.5033Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCircleFacebook);
export default __webpack_public_path__ + "static/media/icon-circle-facebook.e12cfb4b2ccb69c288331a32edeaf9db.svg";
export { ForwardRef as ReactComponent };